export { default } from 'common/interfaces/address';
